module.exports = __webpack_public_path__ + "static/gplay-f6b1c78c081f5e81b23849238bf67053.png";